import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@src/store';

/**
 * 統合PDFアクセスURLスライス
 * Resume用とRirekisho用のPDFアクセストークンを1つのスライスで管理
 */

type UnifiedPdfAccessUrlState = {
  resume: {
    token: string;
  };
  rirekisho: {
    token: string;
  };
};

const initialState: UnifiedPdfAccessUrlState = {
  resume: {
    token: '',
  },
  rirekisho: {
    token: '',
  },
};

const unifiedPdfAccessUrlSlice = createSlice({
  name: 'unifiedPdfAccessUrl',
  initialState,
  reducers: {
    // Resume用のreducers
    updateResumePdfAccessToken(state: UnifiedPdfAccessUrlState, action: PayloadAction<string>) {
      state.resume.token = action.payload;
    },

    // Rirekisho用のreducers
    updateRirekishoPdfAccessUrl(state: UnifiedPdfAccessUrlState, action: PayloadAction<string>) {
      state.rirekisho.token = action.payload;
    },
  },
});

export const {
  // Resume actions

  // Rirekisho actions
  updateRirekishoPdfAccessUrl,
} = unifiedPdfAccessUrlSlice.actions;

// 後方互換性のためのエイリアス
export const updatePdfAccessToken = unifiedPdfAccessUrlSlice.actions.updateResumePdfAccessToken;

// Selectors
const _selectResumePdfAccessToken = (state: RootState) => state.unifiedPdfAccessUrl.resume.token;
export const selectRirekishoPdfAccessToken = (state: RootState) =>
  state.unifiedPdfAccessUrl.rirekisho.token;
// 後方互換性のためのエイリアス
export const selectPdfAccessToken = (state: RootState) => state.unifiedPdfAccessUrl.resume.token;

export default unifiedPdfAccessUrlSlice.reducer;
